export default {
  // 设置默认图片
  defaultImg() {
    return 'this.src="' + require('@/assets/images/default.png') + '"'
  },
  defaultAd() {
    return 'this.src="' + require('@/assets/images/bannerthree.png') + '"'
  },
  defaultAvatar() {
    return 'this.src="' + require('@/assets/images/Headportrt.png') + '"'
  },
  defaultDraw() {
    return 'this.src="' + require('@/assets/draw/banner.png') + '"'
  },
  primaryColor() {
    return '#EF6C00'
  },
  splitString(value) {
    if (!value) {
      return
    }
    let arr = value.split(',')
    return arr
  },
  renderTime(date) {
    if (!date) {
      return
    }
    var dateee = new Date(date).toJSON()
    return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  },
  isLogin() {
    let token = localStorage.getItem('token')
    window.console.log('token', token)
    if (token) {
      return true
    } else {
      return false
    }
  },
  /*
* 获取某个元素下标
* arr: 传入的数组
* obj: 需要获取下标的元素
* */
  getArrayIndex(arr, obj) {
    var i = arr.length
    while (i--) {
      if (arr[i] === obj) {
        return i
      }
    }
    return -1
  },
  uuid() {
    var s = []
    var hexDigits = "0123456789abcdef"
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = "4"
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23] = "-"
    var uuid = s.join("")
    return uuid
  },
  showPic(url, params) {
    if (url && params && url.indexOf('https://xieku.oss-cn-beijing.aliyuncs.com') != -1) {
      return url + params
    }
    return url
  }
}

